import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_2 = { class: "grid grid-cols-4 gap-x-6 w-9/12 gap-y-6" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-4 gap-x-6 w-9/12 gap-y-6"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "py-1 mr-2"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = { class: "grid grid-cols-4 gap-x-6 w-9/12 gap-y-6 pb-4" }
const _hoisted_8 = {
  key: 1,
  class: "col-span-2"
}
const _hoisted_9 = {
  key: 5,
  class: "col-span-2"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 mb-6 mt-1" }, " Anda bisa mengaktifkan status ini kapan saja ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    scrollSidebar: "",
    "custom-class": "px-0 pb-6",
    title: "Edit Konfigurasi",
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[17] || (_cache[17] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    loading: _ctx.apiDetailData.loading,
    onLeavePage: _ctx.onLeavePage,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    "top-right": _withCtx(() => [
      (!_ctx.apiDetailData.errorType)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_lp_button, {
              "text-color": "white",
              customClass: "w-full py-2.5",
              title: "Simpan",
              onClick: _ctx.onSubmit,
              disabled: !_ctx.isFormValid
            }, null, 8, ["onClick", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    data: _withCtx(() => [
      _createVNode(_component_Title, { label: "Detail Informasi Konfigurasi" }),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "ID Konfigurasi",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.detailData.data.dfdcId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.data.dfdcId = $event)),
              placeholder: "ID Konfigurasi",
              disabled: "",
              disableBackground: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Nama Konfigurasi",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.detailData.data.dfdcName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.data.dfdcName = $event)),
              placeholder: "Nama Konfigurasi",
              disabled: "",
              disableBackground: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-4",
          label: "Deskripsi Konfigurasi",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.detailData.data.dfdcDescription,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.data.dfdcDescription = $event)),
              placeholder: "Ketik Deskripsi Konfigurasi"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              class: "col-span-2",
              label: "Kode Alasan",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.data.dfdcReasonCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.data.dfdcReasonCode = $event)),
                  placeholder: "Kode Alasan",
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              class: "col-span-2",
              label: "Kategori Alasan",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.data.dfdcReasonCategory,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.data.dfdcReasonCategory = $event)),
                  placeholder: "Kategori Alasan",
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Title, { label: "Parameter" }),
      (_ctx.detailData.data.dfdcType === 'reason_closed_address')
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Tipe Alamat",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.data.dfdcTypeAddress,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailData.data.dfdcTypeAddress = $event)),
                  placeholder: "Tipe Alamat",
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Jam Dimulai",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.detailData.data.dfdcOfficeStartTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailData.data.dfdcOfficeStartTime = $event)),
                  showDatePicker: false,
                  showTimePicker: "",
                  customClass: "w-full mt-2",
                  manualInput: "",
                  showChevron: false,
                  placeholder: "00:00",
                  key: _ctx.detailData.data.dfdcOfficeStartTime,
                  isError: false,
                  setDefaultDate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Jam Berakhir",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  class: "w-full mt-2",
                  modelValue: _ctx.detailData.data.dfdcOfficeEndTime,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.detailData.data.dfdcOfficeEndTime = $event)),
                  showDatePicker: false,
                  showTimePicker: "",
                  manualInput: "",
                  showChevron: false,
                  placeholder: "00:00",
                  key: _ctx.detailData.data.dfdcOfficeEndTime,
                  isError: false,
                  setDefaultDate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Kecualikan Akhir Pekan & Hari Libur"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CheckboxV2, {
                  label: 
              _ctx.detailData.data.dfdcOfficeExcludeWeekendHoliday ? 'Ya' : 'Tidak'
            ,
                  class: "mt-2 mb-2 ml-2",
                  textSize: 14,
                  value: _ctx.detailData.data.dfdcOfficeExcludeWeekendHoliday,
                  disabled: false,
                  "onUpdate:value": _cache[9] || (_cache[9] = value => _ctx.onUpdateCheckBox(value, 'office'))
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailData.data.dfdcType === 'reason_closed_address')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_7, [
        (_ctx.detailData.data.dfdcType === 'reason_closed_address')
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              class: "col-span-2",
              label: "Tipe Alamat",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.detailData.data.dfdcTypeSecondAddress,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailData.data.dfdcTypeSecondAddress = $event)),
                  placeholder: "Tipe Alamat",
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.detailData.data.dfdcType === 'reason_closed_address')
          ? (_openBlock(), _createBlock("div", _hoisted_8))
          : _createCommentVNode("", true),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              class: "col-span-2",
              label: "Jam Dimulai",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.detailData.data.dfdcParamStartTime,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailData.data.dfdcParamStartTime = $event)),
                  showDatePicker: false,
                  showTimePicker: "",
                  customClass: "w-full mt-2",
                  manualInput: "",
                  showChevron: false,
                  placeholder: "00:00",
                  key: _ctx.detailData.data.dfdcParamStartTime,
                  isError: false,
                  setDefaultDate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 3,
              class: "col-span-2",
              label: "Jam Berakhir",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  class: "w-full mt-2",
                  modelValue: _ctx.detailData.data.dfdcParamEndTime,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.detailData.data.dfdcParamEndTime = $event)),
                  showDatePicker: false,
                  showTimePicker: "",
                  manualInput: "",
                  showChevron: false,
                  placeholder: "00:00",
                  key: _ctx.detailData.data.dfdcParamEndTime,
                  isError: false,
                  setDefaultDate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 4,
              class: "col-span-2",
              label: "Kecualikan Akhir Pekan & Hari Libur"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CheckboxV2, {
                  label: 
              _ctx.detailData.data.dfdcParamExcludeWeekendHoliday ? 'Ya' : 'Tidak'
            ,
                  class: "mt-2 mb-2 ml-1",
                  textSize: 14,
                  value: _ctx.detailData.data.dfdcParamExcludeWeekendHoliday,
                  disabled: false,
                  "onUpdate:value": _cache[13] || (_cache[13] = value => _ctx.onUpdateCheckBox(value, 'house'))
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.sourceDex)
          ? (_openBlock(), _createBlock("div", _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 6,
              class: "col-span-2",
              label: "Genesis"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CheckboxV2, {
                  label: _ctx.detailData.data.dfdcGenesis ? 'Ya' : 'Tidak',
                  class: "mt-2 mb-2 ml-2",
                  textSize: 14,
                  value: _ctx.detailData.data.dfdcGenesis,
                  disabled: false,
                  "onUpdate:value": _cache[14] || (_cache[14] = value => _ctx.onUpdateCheckBox(value, 'genesis'))
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.sourceDex)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 7,
              class: "col-span-2",
              label: "Driver Apps"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CheckboxV2, {
                  label: _ctx.detailData.data.dfdcDriverApp ? 'Ya' : 'Tidak',
                  class: "mt-2 mb-2 ml-2",
                  textSize: 14,
                  value: _ctx.detailData.data.dfdcDriverApp,
                  disabled: false,
                  "onUpdate:value": _cache[15] || (_cache[15] = value => _ctx.onUpdateCheckBox(value, 'driver'))
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Status Konfigurasi Automasi Indikasi DEX Palsu"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_Toggle, {
              onChange: _ctx.onUpdateStatus,
              modelValue: _ctx.isActive,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.isActive = $event)),
              textActive: "Aktif",
              textInactive: "Tidak Aktif"
            }, null, 8, ["onChange", "modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            label: _ctx.detailData.data.dfdcStatus
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Dibuat",
        value: _ctx.detailData.data.formatCreatedAt,
        caption: _ctx.detailData.data.dfdcCreatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Diperbarui",
        value: _ctx.detailData.data.formatUpdatedAt,
        caption: _ctx.detailData.data.dfdcUpdatedBy
      }, null, 8, ["value", "caption"]),
      _withDirectives(_createVNode(_component_LpButton, {
        title: "Ubah",
        customClass: "w-1/2",
        onClick: _ctx.goToEdit,
        outline: "",
        textColor: "red-lp-100"
      }, null, 8, ["onClick"]), [
        [_vShow, _ctx.isEditAble]
      ])
    ]),
    _: 1
  }, 8, ["onBack", "leave-page-confirmation", "loading", "onLeavePage", "error", "errorType", "onTryAgain"]))
}